import { render, staticRenderFns } from "./DcmPropertiesForm.vue?vue&type=template&id=2a4e65ba&scoped=true"
import script from "./DcmPropertiesForm.vue?vue&type=script&lang=ts"
export * from "./DcmPropertiesForm.vue?vue&type=script&lang=ts"
import style0 from "./DcmPropertiesForm.vue?vue&type=style&index=0&id=2a4e65ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e65ba",
  null
  
)

export default component.exports